/* unplugin-vue-components disabled */import { render } from "./signal-activity.vue?vue&type=template&id=716bd132&scoped=true"
import script from "./signal-activity.vue?vue&type=script&lang=js"
export * from "./signal-activity.vue?vue&type=script&lang=js"

import "./signal-activity.vue?vue&type=style&index=0&id=716bd132&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716bd132"],['__file',"src/pages/pulse/signal/signal-activity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "716bd132"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('716bd132', __exports__)) {
    api.reload('716bd132', __exports__)
  }
  
  module.hot.accept("./signal-activity.vue?vue&type=template&id=716bd132&scoped=true", () => {
    api.rerender('716bd132', render)
  })

}


export default __exports__